import {
    onReceivedColumnWidthChangedInternalMutator,
    onSortedContentColumnWidthChangedInternalMutator,
} from '../mutators/columnWidthMutators';

export function onSortedContentColumnHandleChanged(
    sortedContentColumnWidth: number,
    receivedColumnWidth: number
): void {
    // Update store
    onSortedContentColumnWidthChangedInternalMutator(sortedContentColumnWidth);
    onReceivedColumnWidthChangedInternalMutator(receivedColumnWidth);
}
